const variantBtnClick = document.querySelectorAll(
    "#variant-radios fieldset > div"
);

if (variantBtnClick) {
    Array.from(variantBtnClick).forEach((b) => {
        b.addEventListener("click", function (e) {
            e.preventDefault();

            const productFeatureMedia = document.querySelector(
                ".swiper-slide-active .bls__responsive-image.product-single__media img"
            );

            const imgChange = b.querySelector("figure img");

            if (!imgChange) return false;

            const imgAttr = imgChange.getAttribute("src");

            if (!productFeatureMedia) return false;

            productFeatureMedia.removeAttribute("srcset");
            productFeatureMedia.setAttribute("src", imgAttr);
        });
    });
}

//Select Variants
const selectVars = document.querySelector(".sticky-addcart-opstion");

function formatPrice(value, divider = 1) {
    const valorEmReal = (value / 100 / divider).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });

    return valorEmReal;
}

function calcularPorcentagemDesconto(valorOriginal, valorComDesconto) {
    if (
        valorOriginal <= 0 ||
        valorComDesconto <= 0 ||
        valorComDesconto > valorOriginal
    ) {
        throw new Error(
            "Valores inválidos. O valor com desconto deve ser menor que o valor original e ambos devem ser maiores que zero."
        );
    }

    const porcentagemDesconto =
        ((valorOriginal - valorComDesconto) / valorOriginal) * 100;
    return porcentagemDesconto;
}

if (selectVars) {
    selectVars.addEventListener("change", function (e) {
        const textTarget = selectVars.selectedOptions[0].textContent;
        const regexValor = /R\$\s*\d[\d,\.]*/;
        const match = textTarget.match(regexValor);
        const valor = match ? match[0] : null;

        //productVariantsOpt
        const var_id = parseInt(selectVars.value);

        if (productVariantsOpt) {
            const var_change = productVariantsOpt.filter(
                (i) => i.id === var_id
            );

            const compatePriceContainer = document.querySelector(
                ".sticky-addcart-infos .product_collection_prices .price__sale .compare-price"
            );

            const discount = calcularPorcentagemDesconto(
                var_change[0].compare_at_price,
                var_change[0].price
            );

            const discount_flag = document.querySelector(
                ".sticky-addcart-infos .product_collection_prices .price_options_label"
            );

            if (discount_flag) {
                discount_flag.innerHTML = `${parseInt(discount)}% OFF`;
            }

            //price_options_label

            if (compatePriceContainer) {
                compatePriceContainer.innerHTML = formatPrice(
                    var_change[0].compare_at_price,
                    1
                );
            }
        }

        const attributesClick = document.querySelectorAll(
            ".btn_select_attributes > h3"
        );

        if (!attributesClick) return false;

        const targetToImage = document.querySelector(
            ".bls__sticky-addcart .sticky-addcart-img img"
        );

        const priceContainer = document.querySelector(
            ".bls__sticky-addcart .special-price"
        );

        const headingContainer = document.querySelector(
            ".sticky-addcart-infos > .heading-weight"
        );

        const smallText = document.createElement("small");
        smallText.style.width = `100%`;
        smallText.style.display = `block`;
        smallText.classList.add("smallTitleVariation");

        for (const attr of attributesClick) {
            if (textTarget.includes(attr.innerHTML)) {
                const imgToSet = attr
                    .closest(".bls__option-swatch")
                    .querySelector("figure img")
                    .getAttribute("src");

                if (targetToImage && imgToSet) {
                    targetToImage.setAttribute("src", imgToSet);
                    targetToImage.removeAttribute("srcset");
                }

                smallText.innerHTML = attr.innerHTML;

                if (headingContainer) {
                    if (headingContainer.querySelector(".smallTitleVariation"))
                        headingContainer
                            .querySelector(".smallTitleVariation")
                            .remove();
                    headingContainer.append(smallText);
                }

                if (priceContainer) priceContainer.innerHTML = valor;
            }
        }
    });
}

const miniCartButton = document.querySelector(
    ".header-middle .bls__header_minicart"
);

// if (miniCartButton) {
//     miniCartButton.addEventListener("click", function (e) {
//         e.preventDefault();

//         window.location.href = `/cart`;
//     });
// }

const productSelectVariants2 = () => {
    if (!productVariantsOpt) return;
    const selectorVariants = document.querySelectorAll(
        `#variant-radios fieldset label`
    );

    if (!selectorVariants) return;

    function formatPrice(value, divider = 1) {
        const valorEmReal = (value / 100 / divider).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });

        return valorEmReal;
    }

    function calcularPorcentagemDesconto(valorOriginal, valorComDesconto) {
        if (
            valorOriginal <= 0 ||
            valorComDesconto <= 0 ||
            valorComDesconto > valorOriginal
        ) {
            throw new Error(
                "Valores inválidos. O valor com desconto deve ser menor que o valor original e ambos devem ser maiores que zero."
            );
        }

        const porcentagemDesconto =
            ((valorOriginal - valorComDesconto) / valorOriginal) * 100;
        return porcentagemDesconto;
    }

    function handle_sale_text(val, disc, image) {
        const badge = document.querySelector(`.price_options_label`);

        // Obtém o elemento select
        const selectElement = document.querySelectorAll(
            ".sticky-addcart-opstion"
        );

        if (selectElement) {
            // Valor que você quer selecionar
            const var_id = image.id;

            // Loop através das opções do select
            for (let i = 0; i < selectElement.length; i++) {
                const option = selectElement[i];

                // Verifica se o valor da opção é igual ao valor desejado
                option.value = var_id;
                option.dispatchEvent(new Event("change"));
            }
        }

        if (!badge) return;

        const PriceElement = document.querySelector(".price.special-price");
        const PriceElementAnt = document.querySelector(
            ".price-item.compare-price"
        );

        if (PriceElementAnt) {
            PriceElementAnt.innerHTML = `${formatPrice(val)}`;
        }
        if (PriceElement) {
            PriceElement.innerHTML = `${formatPrice(disc)}`;
        }

        if (val) {
            setTimeout(() => {
                const btnAddToCart = document.querySelector(
                    ".bls__product-action-inner .product-form__submit"
                );

                if (btnAddToCart) {
                    btnAddToCart.removeAttribute("disabled");
                }
                if (image) {
                    const carouselImage = document.querySelector(
                        ".product__media-list .swiper-slide-active .gallery-img img"
                    );

                    if (carouselImage) {
                        carouselImage.removeAttribute("srcset");
                        carouselImage.setAttribute(
                            "src",
                            image.featured_image.src
                        );
                    }
                }
                return (badge.innerHTML = `${parseInt(
                    calcularPorcentagemDesconto(val, disc)
                )}% OFF`);
            }, 250);
        }
    }

    for (let i = 0; i < selectorVariants.length; i++) {
        const element = selectorVariants[i];

        const img = productVariantsOpt[i].featured_image.src;
        const variant_id = productVariantsOpt[i].id;
        const title = productVariantsOpt[i].title;
        const price = productVariantsOpt[i].price;
        const compare = productVariantsOpt[i].compare_at_price;
        //const compare = false;
        const ebook =
            element.dataset.ebookFlag === "true"
                ? '<span class="variant-flag ebook-flag">BÔNUS: E-BOOK</span>'
                : "";
        const freeShipping = `<span class="variant-flag free-shipping-flag ${
            price < 9900 && "variant-flag--hidden"
        }">FRETE GRÁTIS</span>`;

        element.addEventListener("click", (e) =>
            handle_sale_text(compare, price, productVariantsOpt[i])
        );

        const divContent = document.createElement(`div`);

        divContent.setAttribute("variant_id", variant_id);

        divContent.className = `btn_select_attributes`;
        divContent.innerHTML = `
          <h3>${title}</h3>
          <figure><img src="${img}" /></figure>
          <span>
              <small>5x sem juros de</small>
              <h3>${formatPrice(price, 5)}</h3>
              <small>ou ${formatPrice(price)} à vista</small>
          </span>
        `;
        element.innerHTML = ``;
        element.style.display = `flex`;
        element.style.flexDirection = `column`;
        //element.style.width = `180px`
        //element.style.height = `300px`
        element.append(divContent);
    }
};

productSelectVariants2();
